import { colors } from '../../colors';
var imageGallery = {
  primaryColor: colors.white,
  bgColor: colors.lead,
  tileBgColor: colors.lightPink,
  iconBgColor: colors.lead
};
export default imageGallery;